export const STRONG_PASSWORD = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*()_+])[A-Za-z\d][A-Za-z\d!@#$%^&*()_+]{6,14}$/;


// WEBPACK FOOTER //
// ./src/constants/regex.js